<!-- use tags -->

import Layout1 from "../../src/routes/_main-site/+layout.marko";
import Page from "../../src/routes/_main-site/bucket-list/+page.marko";

<Layout1>
	<Page/>
</>
